import {
  Button,
  Divider,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  VStack,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { useUser } from "../../context/UserContext";
import profileSchema from "./schema/profileSchema";

const Profile = () => {
  const user = useUser()

  return (
    <>
      <Heading size={"md"}>Profile</Heading>
      <Divider borderColor={"gray.300"} />
      <Formik
        initialValues={user}
        validationSchema={profileSchema}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            actions.setSubmitting(false);
          }, 1000);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <VStack align={"flex-start"} mb={5} gap={10}>
              <VStack gap={5} align={"flex-start"}>
                <Field name="firstName">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form.errors.firstName && form.touched.firstName
                      }
                    >
                      <FormLabel>First Name</FormLabel>
                      <Input {...field} type="text" />
                      <FormHelperText>
                        First name is required once you setted
                      </FormHelperText>
                      <FormErrorMessage>
                        {form.errors.firstName}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="lastName">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form.errors.lastName && form.touched.lastName}
                    >
                      <FormLabel>Last Name</FormLabel>
                      <Input {...field} type="text" />
                      <FormHelperText>
                        Last name is required once you setted
                      </FormHelperText>
                      <FormErrorMessage>
                        {form.errors.lastName}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="phone">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form.errors.phone && form.touched.phone}
                    >
                      <FormLabel>Phone</FormLabel>
                      <Input {...field} type="text" />
                      <FormHelperText>
                        Phone number can be empty. You can remove it any time
                      </FormHelperText>
                      <FormErrorMessage>{form.errors.phone}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Button
                  type="submit"
                  colorScheme="blue"
                  isLoading={isSubmitting}
                  loadingText="Saving..."
                >
                  Save Profile
                </Button>
              </VStack>
            </VStack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Profile;
